﻿import { Map } from "mapbox-gl";
import { autorun } from 'mobx';
import { Options as LayerOptions } from 'ol/layer/Layer';
import { ChartBackground, ChartHybrid, ChartType, isMsgChart } from "../../models/ChartModels";
import { ChartStates } from '../../models/ChartStates';
import MapBoxLayer from "../MapBoxLayer";

export interface OsmVectorLayerOptions {
    container?: string;
    adjustZoom?: number;
}

class OsmVectorLayer extends MapBoxLayer {

    constructor(states: ChartStates, url: string, osmVectorLayerOptions?: OsmVectorLayerOptions, layerOptions?: LayerOptions) {
        super(new Map({
            style: url,
            attributionControl: false,
            boxZoom: false,
            center: [0, 0],
            container: osmVectorLayerOptions?.container ?? 'map',
            doubleClickZoom: false,
            dragPan: false,
            dragRotate: false,
            fadeDuration: 0,
            interactive: false,
            keyboard: false,
            pitchWithRotate: false,
            scrollZoom: false,
            touchZoomRotate: false,
            //antialias: false,
            //accessToken:"pk.eyJ1IjoiaWxsb2dpY3oiLCJhIjoiY2s3MzVja21hMDhxcTNrbWlpcW1zNXJidyJ9.oFY-i3KCGnODbDDtZWgTAg",
            bounds: [-5000, -90, 5000, 90],
            maxBounds: [-5000, -90, 5000, 90],
            minZoom: -1,
            maxTileCacheSize: 400,
            //localIdeographFontFamily: "sans-serif",
            ...(osmVectorLayerOptions ?? {})
        }), layerOptions, osmVectorLayerOptions?.adjustZoom ?? -1);

        this.mobxDisposer.add([
            autorun(() => {
                const chart = states.chart;
                this.setVisible(chart.type === ChartType.OpenStreetMap ||
                    (isMsgChart(chart) && chart.hybrid === ChartHybrid.Land && chart.background === ChartBackground.OpenStreetMap));
            })
        ]);
    }
}

export default OsmVectorLayer;